import CoreLayout from './components/CoreLayout';
import InlineInputLabel from './components/InlineInputLabel.js';
import GFormCheckboxes from './components/GFormCheckboxes.js';
import MailchimpSignup from './components/MailchimpSignup.js';
import header from './header';

CoreLayout.watchDimensions();

function init() {
  header.init();
  InlineInputLabel.initGforms();
  GFormCheckboxes.init();
  MailchimpSignup.init();
}

document.addEventListener('DOMContentLoaded', init);
